import React from "react";
import {
  KeyboardArrowDownOutlined,
  KeyboardArrowUpOutlined,
} from "@mui/icons-material";
import { styled } from "@mui/material";

export const ExpandButton: React.FC<{
  isExpanded: boolean;
  onExpand: () => void;
}> = ({ isExpanded, onExpand }) => {
  return (
    <StyledButton
      onClick={(e) => {
        e.stopPropagation();
        onExpand();
      }}
    >
      {isExpanded ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
    </StyledButton>
  );
};

const StyledButton = styled("div")(({ theme }) => ({
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  height: "-webkit-fill-available",
  width: "36px",
  boxSizing: "border-box",
  svg: {
    width: "1.5rem",
    fill: theme.tokens.colors.gray[6],
    height: "1.5rem",
  },
}));
